@if (!ShowOfflineNotSupportedPage && !_cs.isonlineStatus) {
  <app-title [ngClass]="{'d-none': _cs.ReceivingMenu !== _cs.ReceivingRouteUrl }" [options]="_cs.titleOptions" >
  </app-title>
}
<div class="off-no-data-wrapper">
  <div class="off-no-data-container">
    <p class="text-top">{{textLineTop}}</p>
    <img src="assets/images/Offline.png" alt="imageAltText" class="offline-no-dataImg">
    <p class="text-bottom">{{textLineBottom}}</p>
  </div>
</div>